module.exports = __webpack_public_path__ + "static/img/profile.473f597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/profile.jpg
// module id = AY2A
// module chunks = 0